/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet  } from '@react-pdf/renderer';
// import userprofile from '../../../images/user.png';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		minHeight: 20,
	},

	
	Id: {
		width: '6%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		fontSize: 6,
		textAlign: 'center',
		paddingVertical: 4,
	},

	Name: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center',
		paddingVertical: 4,
	},

	Email: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center',
		paddingVertical: 4,
	},

	CellPhone: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center',
		paddingVertical: 4,
	},

	Usertype: {
		width: '10%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center',
		paddingVertical: 4,
	},

	Profile: {
		width: '11%',
		borderRightWidth: 1,
		borderRightColor: borderColor,
		fontSize: 6,
		textAlign: 'center',
		paddingVertical: 4,
	},

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	},
});

const InvoiceTableRow = (props) => {

	const rows = props.data?.map((item, index) => (
		<View key={index}>
			<View style={styles.row}>
				<Text style={styles.Id}>{item.id}</Text>
				<Text style={styles.Name}>{item.name}</Text>
				<Text style={styles.Email}>{item.totaldistance}</Text>
				<Text style={styles.CellPhone}>{item.covereddistance?.toFixed?.(5)}</Text>
				<Text style={styles.Usertype}>{item.avgvelocity}</Text>
				<Text style={styles.Profile}>{item.coverage}</Text>
				<Text style={styles.Profile}>{item.idletime}</Text>
				<Text style={styles.Profile}>{item.speedviolation}</Text>
				<Text style={styles.Profile}>{item.totalTravelledDist}</Text>
				<Text style={styles.Profile}>{item.vehicleNumber}</Text>
				<Text style={styles.Profile}>{item.allocationId}</Text>
				<Text style={styles.Profile}>{item.systemgrade}</Text>
				<Text style={styles.Profile}>{item.finalgrade}</Text>
				<Text style={styles.Profile}>{item.minStart}</Text>
				<Text style={styles.Profile}>{item.maxEnd}</Text>
			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;